import { ArrowUDownLeftIcon } from "@phosphor-icons/react/dist/csr/ArrowUDownLeft";
import { UserSwitchIcon } from "@phosphor-icons/react/dist/csr/UserSwitch";
import { useNavigate } from "react-router-dom";
import { CommandGroup, CommandItem } from "@volca/ui/components/ui/command";
import { toast } from "@volca/ui/lib/toast";
import { useImpersonation } from "@/core/impersonation";

export const ImpersonationCommands = ({
  onImpersonate,
  onClose,
}: {
  onImpersonate: () => void;
  onClose: () => void;
}) => {
  const { isImpersonating, endImpersonation, isSavePending } =
    useImpersonation();
  const navigate = useNavigate();
  const label = isImpersonating
    ? "Switch impersonation"
    : "Start impersonation";

  const stop = async () => {
    onClose();
    try {
      await endImpersonation();
      void navigate("/");
    } catch (error) {
      toast.error("Couldn't stop impersonating. Try again.", {
        description: error instanceof Error ? error.message : undefined,
      });
    }
  };

  return (
    <CommandGroup heading="Actions">
      <CommandItem value={`${label} user identity`} onSelect={onImpersonate}>
        <UserSwitchIcon />
        <span>{label}</span>
      </CommandItem>
      {isImpersonating && (
        <CommandItem
          value="stop impersonation stop impersonating return to my account"
          disabled={isSavePending}
          onSelect={() => void stop()}
        >
          <ArrowUDownLeftIcon />
          <span>Stop impersonation</span>
        </CommandItem>
      )}
    </CommandGroup>
  );
};
